export const YOY_BANDS = { strong: 10, mild: 2 } as const;
export const LIFT_STRONG = 10;
export const REPEAT_VISITOR_HIGH = 0.4;
export const REPEAT_VISITOR_LOW = 0.15;
export const DWELL_LONG_MIN = 12;
export const DWELL_SHORT_MAX = 5;
export const PEAK_SHARE_DOMINANT = 0.25;
